export function snooze(ms: number): Promise<NodeJS.Timeout> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}
